import { render } from "./level.html?vue&type=template&id=5b18d04a&scoped=true&ts=true"
import script from "./level.ts?vue&type=script&lang=ts"
export * from "./level.ts?vue&type=script&lang=ts"

import "./level.scss?vue&type=style&index=0&id=5b18d04a&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b18d04a"]])

export default __exports__